<template>
  <div class="menuCartButtonContainer">
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="40"
        height="40"
        rx="8"
        fill="white"
      />
      <path
        transform="translate(0,-7)"
        d="M18.1239 36.584C18.1239 37.0148 17.9934 37.4359 17.749 37.7941C17.5045 38.1523 17.157 38.4314 16.7505 38.5963C16.344 38.7611 15.8967 38.8043 15.4651 38.7202C15.0335 38.6362 14.6371 38.4287 14.326 38.1241C14.0148 37.8195 13.8029 37.4314 13.7171 37.0089C13.6312 36.5864 13.6753 36.1484 13.8437 35.7504C14.0121 35.3524 14.2972 35.0122 14.6631 34.7729C15.029 34.5336 15.4591 34.4058 15.8991 34.4058C16.4883 34.4087 17.0525 34.6391 17.4691 35.047C17.8856 35.4548 18.121 36.0072 18.1239 36.584ZM27.468 34.4058C27.028 34.4058 26.5978 34.5336 26.232 34.7729C25.8661 35.0122 25.5809 35.3524 25.4126 35.7504C25.2442 36.1484 25.2001 36.5864 25.286 37.0089C25.3718 37.4314 25.5837 37.8195 25.8948 38.1241C26.206 38.4287 26.6024 38.6362 27.034 38.7202C27.4655 38.8043 27.9128 38.7611 28.3194 38.5963C28.7259 38.4314 29.0734 38.1523 29.3178 37.7941C29.5623 37.4359 29.6928 37.0148 29.6928 36.584C29.6898 36.0072 29.4545 35.4548 29.0379 35.047C28.6213 34.6391 28.0571 34.4087 27.468 34.4058ZM32.9521 21.2608L30.2601 30.4525C30.0725 31.0882 29.6795 31.6472 29.14 32.0458C28.6005 32.4444 27.9436 32.6611 27.2678 32.6633H16.0994C15.4235 32.6611 14.7666 32.4444 14.2271 32.0458C13.6876 31.6472 13.2946 31.0882 13.107 30.4525L10.4262 21.2826C10.4262 21.2717 10.415 21.2499 10.415 21.239L9.42501 17.852H8.33487C7.98084 17.852 7.64131 17.7143 7.39097 17.4693C7.14064 17.2242 7 16.8918 7 16.5452C7 16.1986 7.14064 15.8661 7.39097 15.6211C7.64131 15.376 7.98084 15.2383 8.33487 15.2383H9.75873C10.2421 15.2419 10.7115 15.3972 11.098 15.6815C11.4845 15.9657 11.7675 16.3639 11.9056 16.8174L12.7066 19.5945H31.6617C31.8682 19.5957 32.0716 19.6433 32.2563 19.7338C32.4409 19.8242 32.6018 19.9551 32.7266 20.1161C32.8513 20.2772 32.9365 20.4643 32.9756 20.6627C33.0147 20.8612 33.0067 21.0659 32.9521 21.2608ZM29.893 22.2083H13.4741L15.6655 29.7337C15.694 29.8248 15.7514 29.9046 15.8295 29.9614C15.9075 30.0182 16.0021 30.0491 16.0994 30.0496H27.2678C27.365 30.0491 27.4596 30.0182 27.5376 29.9614C27.6157 29.9046 27.6731 29.8248 27.7016 29.7337L29.893 22.2083Z"
        fill="var(--brandPrimary)"
      />
    </svg>
    <div class="number flex-row justify-content-center align-items-center padding4">
      {{ cartSize }}
    </div>
  </div>
</template>

<script>
export default {
  name: "MenuButtonCartOff",
  props: {
      cartSize: {
        type: Number,
        default: 0,
      }
  }
}
</script>

<style scoped>
.number {
  position: absolute;
  width: 18px;
  height: 18px;
  right: -7px;
  top: -7px;
  background: var(--black);
  border-radius: 40px;
  flex: none;
  order: 1;
  flex-grow: 0;
  z-index: 1;
  color: white;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 7px;
}
.menuCartButtonContainer {
  position: relative;
  width: 40px;
  height: 40px;
  isolation: isolate;
}
</style>